var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tax Scenario Icons - Colour",
    clipPath: "url(#clip0_5830_888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.79803H10.5L8.5 6.79803V8.79803H2.5V15.798H10.5V13.798H12.5V8.79803H10.5V6.79803H12.5V4.79803ZM12.5 17.798H10.5V16.798H3.51V22.798H12.5V17.798Z",
    fill: "#14AA3C"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 13.5,
    y1: 2.79803,
    x2: 13.5,
    y2: 24.798,
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 13.5,
    y: 7.79803,
    width: 8,
    height: 14,
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M19 13.9647V12.8814H17.5M16 16.1314V17.2147H17.5M17.5 12.8814H16V15.048H19V17.2147H17.5M17.5 12.8814V11.798M17.5 17.2147V18.298",
    stroke: "#6E6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5830_888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.798035)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario5);
export default __webpack_public_path__ + "static/media/Scenario5.7de7b2c3f88c6f8c93384b7ca3818b21.svg";
export { ForwardRef as ReactComponent };